import { render, staticRenderFns } from "./EditSale.vue?vue&type=template&id=60f1584b&scoped=true&"
import script from "./EditSale.vue?vue&type=script&lang=js&"
export * from "./EditSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f1584b",
  null
  
)

export default component.exports